var _circle, _polygon, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Sync50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#3dd9eb"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#c2ffff",
    points: "36,13 27.527,18.965 36,22"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c2ffff",
    d: "M31.294,18.759l3.278-2.307C32.212,13.154,28.355,11,24,11c-6.487,0-11.863,4.78-12.83,11h4.062 c0.913-4.002,4.494-7,8.768-7C27.005,15,29.659,16.489,31.294,18.759z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.294,18.759l3.278-2.307c-0.391-0.546-0.837-1.048-1.306-1.527l-3.326,2.341 C30.444,17.713,30.9,18.211,31.294,18.759z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#c2ffff",
    points: "12,35 20.473,29.035 12,26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c2ffff",
    d: "M16.706,29.241l-3.278,2.307C15.788,34.846,19.645,37,24,37c6.487,0,11.863-4.78,12.83-11h-4.062 c-0.913,4.002-4.494,7-8.768,7C20.995,33,18.341,31.511,16.706,29.241z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.706,29.241l-3.278,2.307c0.391,0.546,0.837,1.048,1.306,1.527l3.326-2.341 C17.556,30.287,17.1,29.789,16.706,29.241z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Sync50);
export default __webpack_public_path__ + "static/media/icons8-sync-50.64c1c00c6394929fc4330af24964247e.svg";
export { ForwardRef as ReactComponent };